import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { validNumber } from "@/utils/calculators";

type Props = {
    wallArea: number;
    windowArea: number;
    doorArea: number;
    rollArea: number;
    mailParams: any;
};

const Result = ({
    wallArea,
    windowArea,
    doorArea,
    rollArea,
    mailParams
}: Props) => {
    const { t } = useGranite();

    const rollAreaNeeded = (): number => {
        const rollAreaNeeded = Number(wallArea - windowArea - doorArea).toFixed(
            2
        );

        return validNumber(Number(rollAreaNeeded)) ? Number(rollAreaNeeded) : 0;
    };
    const nettRollNeeded = () => {
        const nettRollNeeded = Number(rollAreaNeeded() / rollArea).toFixed(2);
        return validNumber(Number(nettRollNeeded)) ? Number(nettRollNeeded) : 0;
    };
    const rollNeeded = () => {
        const rollNeeded = Number(Math.ceil(nettRollNeeded())).toFixed(0);
        return validNumber(Number(rollNeeded)) ? rollNeeded : 0;
    };

    return (
        <div id="result">
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.wallpaperCalculator.wallArea")}
                    unit={"m"}
                    sup={2}
                    value={Number(wallArea).toFixed(2)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.wallpaperCalculator.windowArea")}
                    unit={"m"}
                    sup={2}
                    value={Number(windowArea).toFixed(2)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.wallpaperCalculator.doorArea")}
                    unit={"m"}
                    sup={2}
                    value={Number(doorArea).toFixed(2)}
                />
            </Row>
            <Row>
                <Col>
                    <h4>
                        {t(
                            "calculator.wallpaperCalculator.wallpaperAmountNeeded"
                        )}
                    </h4>
                </Col>
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t(
                        "calculator.wallpaperCalculator.wallpaperAreaNeeded"
                    )}
                    unit={"m"}
                    sup={2}
                    value={rollAreaNeeded()}
                />
            </Row>
            <Row>
                <ResultField
                    sm={6}
                    md={4}
                    lg={3}
                    copy={t(
                        "calculator.wallpaperCalculator.wallpaperNettRollNeeded"
                    )}
                    value={nettRollNeeded()}
                />
                <ResultField
                    sm={6}
                    md={4}
                    lg={3}
                    copy={t(
                        "calculator.wallpaperCalculator.wallpaperRollNeeded"
                    )}
                    value={rollNeeded()}
                />
            </Row>
        </div>
    );
};

export default Result;
